<template>
  <v-container class="pa-4">
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          fab
          x-small
          :color="site.color"
          @click="redirectTo()"
          dark
          class="mb-4"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="d-flex justify-center">
        <div style="max-height: 240px">
          <img
            :src="pathImage"
            style="
              max-width: 100%;
              max-height: 240px;
              width: auto;
              height: auto;
              border-radius: 10px;
              object-fit: contain;
              display: block;
              margin: 0 auto;
            "
            @error="onImageError($event, missionDetail, 'image_url')"
          />
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-3">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="text-subtitle-1 text--primary mx-0 text-center mb-0">
              {{ missionDetail.name }}
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-3" style="margin-bottom: 160px">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-btn v-if="showCommentField" @click="hideSuveyForm = true" icon>
                <v-icon>mdi-content-save-edit-outline</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12">
            <Survey
              v-if="survey"
              :survey="survey"
              style="border-radius: 8px; background-color: transparent"
            />
          </v-col>
        </v-row>

        <v-row no-gutters :key="componentKey" v-if="displayType">
          <v-col cols="12">
            <vue-plyr ref="plyr">
              <video
                controls
                crossorigin
                playsinline
                data-plyr-config='{ "ratio": "4:3" }'
              >
                <source :src="image_preview" size="720" type="video/mp4" />
              </video>
            </vue-plyr>
          </v-col>
        </v-row>

        <v-row no-gutters v-if="showCommentField" class="mt-3">
          <v-col cols="12">
            <v-textarea
              :label="$t('textDescription')"
              v-model="description"
              solo
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row no-gutters v-if="missionDetail.mission_status == 'failed'">
          <v-col cols="12">
            <v-row no-gutters>
              <v-textarea
                class="mt-3"
                label=""
                outlined
                readonly
                no-resize
                auto-grow
                rows="1"
                v-model="noteFailTextarea"
              >
              </v-textarea>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-footer fixed padless color="white">
      <v-container>
        <v-row justify="center">
          <v-col cols="12">
            <v-row class="pt-4" justify="center">
              <v-col cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  block
                  class="pa-5 rounded-lg white--text"
                  :color="site.color"
                  @click="survey.completeLastPage()"
                >
                  {{ $t("activityUpload") }}
                </v-btn>
              </v-col>
              <v-col cols="11" md="3" class="py-0 pb-4">
                <v-btn
                  block
                  class="pa-5 rounded-lg"
                  :color="site.color"
                  outlined
                  @click="redirectTo()"
                >
                  {{ $t("back") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <DialogRewardMission
      :dialogRewardMission="dialogRewardMission"
      :missionDetail="missionDetail"
      :userAddress="userAddress"
      :detail="detail"
      :isLoading="isLoading"
      @openDialogAddress="dislogAddressVisible = true"
      @confirmMissionReward="confirmUpload"
    />

    <DialogAddressRedeemFinal
      @selectedAddress="handleSelectedAddress"
      :dislogAddressVisible="dislogAddressVisible"
      @close="dislogAddressVisible = false"
      :site="site"
    />
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import moment from "moment";
import "survey-core/defaultV2.min.css";
import { mapState } from "vuex";
import { Survey } from "survey-vue-ui";
import { Model } from "survey-core";
import { themeJson } from "../../../scss/themeJson.js";
import * as htmlToImage from "html-to-image";
import DialogAddressRedeemFinal from "../../../components/reward/dialogAddressRedeemFinal.vue";
import {
  addClassQlEditorToSDDisplay,
  addDivCustomInputMaskPattern,
} from "../../../config/general-function.js";
import DialogRewardMission from "./component/dialogRewardMission.vue";

export default {
  inject: ["isAppLoading"],
  components: {
    Survey,
    DialogAddressRedeemFinal,
    DialogRewardMission,
  },
  data: () => ({
    isLoading: false,
    missionDetail: {
      id: null,
      name: null,
      mission_status: null,
      schema_survey: null,
      image_url: null,
      image_path: null,
      image_upload: null,
      description: null,
      note: null,
    },
    loadingScreen: false,
    drawer: false,
    group: null,
    dataItem: [],
    image_preview: null,
    image: null,
    image_name: "",
    valid: true,
    employee_mission_id: "",
    description: "",
    componentKey: 0,
    displayType: false,
    currentUrl: "",
    survey: null,
    hideSuveyForm: true,

    dialogRewardMission: false,
    dataListAddress: [],
    addressSelect: {},
    addressTitle: "",
    canEdit: true,
    detail: {
      chooseAddress: "self",
      note: "",
      employee_note: "",
      is_use_id_card: false,
      id_card_image: null,
      id_card_image_watermark: null,
      watermark_text: null,
      file: null,
      image_error: null,
    },
    dislogAddressVisible: false,
    userAddress: null,
  }),

  async created() {
    this.addressTitle = this.$t("add");
    this.survey = new Model({});
    this.fetchAddress();
  },
  async mounted() {
    this.isAppLoading(true);
    await this.getMyMissionById(this.$route.params.id);
    this.onInit();
    // ========== ========== ========== ==========
    this.checkUpload();
    this.survey.onComplete.add(this.surveyComplete);
    // ========== ========== ========== ==========
    this.isAppLoading(false);
  },

  methods: {
    redirectTo() {
      this.$router.push({
        name: "my-mission-detail",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    byhtmlToImage(element) {
      return new Promise((resolve) => {
        htmlToImage
          .toPng(element)
          .then((dataUrl) => {
            resolve(dataUrl);
          })
          .catch((error) => {
            console.error("Error byhtmlToImage:", error);
            resolve(null);
          });
      });
    },
    uploadImageDefault(file) {
      if (file) {
        let formData = new FormData();
        formData.append("image", file);
        formData.append("module", "IDCard");
        return new Promise((resolve, reject) => {
          Axios.post("uploadImageDefault", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then(({ data }) => {
              if (data.status == "success") {
                resolve(data.image_url);
              }
            })
            .catch((err) => {
              console.log(err);
              reject(null);
            });
        });
      } else {
        return null;
      }
    },
    async convertDetailImageBase64(data) {
      let listImageSrc = [data];
      const listImageSrcBase64 = listImageSrc
        .filter((x) => x.includes(";base64,"))
        .map((x) => {
          const detail = {
            old: x,
            new: null,
          };
          return detail;
        });
      if (listImageSrcBase64.length > 0) {
        for (let item of listImageSrcBase64) {
          const imageFile = await this.convertBase64ToFile(item.old, "image");
          if (imageFile) {
            const imageUrl = await this.uploadImageDefault(imageFile);
            if (imageUrl) {
              data = data.replace(item.old, imageUrl);
            }
          }
        }
      }
      return data;
    },
    convertBase64ToFile(base64, nameImage) {
      return new Promise((resolve) => {
        const fetchBase64 = fetch(base64);
        fetchBase64
          .then((r) => r.blob())
          .then((blobFile) => {
            const image = new File([blobFile], nameImage, {
              type: blobFile.type,
            });
            resolve(image);
          })
          .catch((err) => {
            console.log("convertBase64ToFile", err);
            resolve(null);
          });
      });
    },

    // ========== ========== Address ========== ==========
    fetchAddress() {
      Axios.get("address/list").then((res) => {
        if (res.data.status == "success") {
          this.dataListAddress = res.data.data.data;
          this.canEdit = res.data.data.can_edit;

          //select first address
          if (this.dataListAddress.length > 0) {
            this.selectAddress(this.dataListAddress[0]);
          }
        }
      });
    },
    selectAddress(item) {
      this.addressSelect = item;
    },
    handleSelectedAddress(chooseAddress) {
      this.userAddress = chooseAddress;
    },

    // ========== ========== ========== ==========
    onInit() {
      this.fetchImage();
      this.currentUrl = window.location.href;
      // this.missionDetail.schema_survey.showCompletedPage = false;
      try {
        this.missionDetail.schema_survey = JSON.parse(
          this.missionDetail.schema_survey
        );
      } catch {
        console.log("JSON.parse(this.missionDetail.schema_survey)");
      }

      if (this.missionDetail.schema_survey) {
        this.missionDetail.schema_survey.showCompletedPage = false;
      }
      this.survey = new Model(this.missionDetail.schema_survey);
      this.survey.showNavigationButtons = false;
      themeJson.cssVariables["--sjs-primary-backcolor"] = this.site.color;
      themeJson.cssVariables["--sjs-primary-backcolor-dark"] = this.site.color;
      this.survey.applyTheme(themeJson);
      // ========== ========== ========== ==========
      // this.onValueChanged();
      this.onAfterRenderPage();
      this.onAfterRenderQuestion();
    },
    onAfterRenderPage() {
      this.survey.onAfterRenderPage.add(function (sender, options) {
        console.log(options);
        addClassQlEditorToSDDisplay();
      });
    },
    onAfterRenderQuestion() {
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        const jsonObj = options.question.jsonObj;
        const prefix = jsonObj._customPrefix;
        const questionEl = options.htmlElement;
        if (prefix) {
          addDivCustomInputMaskPattern(questionEl, prefix);
        }
        addClassQlEditorToSDDisplay();
      });
    },
    async getMyMissionById(id) {
      try {
        const myMission = await Axios.get("mission/getMyMission", {
          params: {
            employee_mission_id: id,
            view_in_period_remind_date: false,
            view_limit_reached: false,
          },
        });
        if (myMission.data?.status == "success") {
          this.missionDetail = JSON.parse(JSON.stringify(myMission.data.data));
          this.detail.employee_note = this.missionDetail?.employee_note || "";
          if (this.missionDetail.not_allowed) {
            this.$swal
              .fire({
                icon: "error",
                title: this.$t("messageActivityErrorReJoin"),
                showConfirmButton: false,
                timer: 4000,
              })
              .then(() => {
                this.isAppLoading(false);
                this.$router.push({
                  name: "mission",
                });
              });
          }
        }
      } catch (err) {
        this.$swal
          .fire({
            icon: "error",
            title: err?.response?.data?.message,
            showConfirmButton: false,
            timer: 4000,
          })
          .then(() => {
            this.isAppLoading(false);
            this.$router.push({
              name: "mission",
            });
          });
      }
    },
    async surveyComplete() {
      for (const key in this.survey.data) {
        const question = this.survey.getQuestionByName(key);
        const nameImage = question.value[0].name;

        if (question.getType() == "file") {
          await this.convertBase64ToFileMission(
            question.displayValue[0].content,
            nameImage
          );
        }
        if (question) {
          this.description = question.value;
        }
      }
      if (
        this.missionDetail.use_reward == true &&
        Array.isArray(this.missionDetail.mission_rewards) &&
        this.missionDetail.mission_rewards.length > 0
      ) {
        this.dialogRewardMission = true;
      } else {
        this.confirmUpload({ rewardSelect: [] });
      }
    },
    convertBase64ToFileMission(base64, nameImage) {
      return new Promise((resolve) => {
        const fetchBase64 = fetch(base64);
        const blob = fetchBase64
          .then((r) => r.blob())
          .then((blobFile) => {
            this.image = new File([blobFile], nameImage, {
              type: blobFile.type,
            });
            this.image_name = nameImage;
          });
        resolve(blob);
      });
    },
    fetchImage() {
      let typeVideo = ["mp4", "mov"];
      let typeImage = ["jpg", "png"];
      this.image_preview = this.missionDetail.image_upload;
      this.description = this.missionDetail.description;
      if (!this.image_preview) {
        return;
      }
      this.hideSuveyForm = false;
      let typeFile = this.image_preview
        .split(/[#?]/)[0]
        .split(".")
        .pop()
        .trim();
      if (typeVideo.some((item) => item == typeFile)) {
        this.displayType = true;
      }
      if (typeImage.some((item) => item == typeFile)) {
        this.displayType = false;
      }
      setTimeout(() => {
        this.componentKey++;
      }, 2000);
    },
    // ========== ========== Check Upload ========== ==========
    checkUpload() {
      this.survey.onValidateQuestion.add((sender, options) => {
        const value = options.value;
        const question = options.question;
        const type = question?.getType();
        if (type == "file") {
          if (value?.length > 0) {
            let checkAcceptedType = false;
            const obj = question?.jsonObj;
            const acceptedTypes = obj?.acceptedTypes;
            const file_name = value[0].name;
            if (acceptedTypes) {
              const acceptedTypeSplit = acceptedTypes.split(",");
              for (let item of acceptedTypeSplit) {
                if (item.includes("image/")) {
                  checkAcceptedType = this.isImage(file_name);
                } else if (item.includes("video/")) {
                  checkAcceptedType = this.isVideo(file_name);
                } else if (item.includes("application/pdf")) {
                  checkAcceptedType = this.isPDF(file_name);
                } else if (
                  item.includes("text/csv") ||
                  item.includes(
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  ) ||
                  item.includes("application/vnd.ms-excel")
                ) {
                  checkAcceptedType = this.isSpreadsheet(file_name);
                } else if (item == "*") {
                  checkAcceptedType = true;
                }
                if (checkAcceptedType) {
                  break;
                }
              }
            } else {
              checkAcceptedType = true;
            }
            if (!checkAcceptedType) {
              options.error = this.$t("invalidFileFormat");
            }
          }
        }
      });
    },
    isImage(link) {
      return /\.(gif|jpe?g|jfif|tiff?|png|webp|bmp|avif|svg)$/i.test(link);
    },
    isVideo(link) {
      return /\.(mp4|webm|ogg|avi|mov)$/i.test(link);
    },
    isPDF(link) {
      return /\.pdf$/i.test(link);
    },
    isSpreadsheet(link) {
      return /\.(xls|xlsx|csv)$/i.test(link);
    },
    // ========== ========== ========== ==========
    async confirmUpload({ rewardSelect }) {
      const isUseIdCard = rewardSelect.some(
        (item) => item.is_use_id_card === true
      );
      this.isLoading = true;

      //-----------------------------------------
      let addressId = null;
      if (this.detail.chooseAddress === "transport") {
        if (!this.userAddress) {
          this.isLoading = false;
          return;
        }
        addressId = this.userAddress.id;
      }
      if (
        isUseIdCard &&
        !this.detail.id_card_image &&
        !this.detail.id_card_image_watermark
      ) {
        this.detail.image_error = true;
        this.isLoading = false;
        return;
      }
      //----------------------------------------------------------------
      if (!this.detail.id_card_image_watermark) {
        const element = document.getElementById("id_card_image");
        if (element) {
          let dataUrl = null;
          dataUrl = await this.byhtmlToImage(element);
          const id_card_image_watermark = await this.convertDetailImageBase64(
            dataUrl
          );
          if (id_card_image_watermark) {
            this.detail.id_card_image_watermark = id_card_image_watermark;
          }
        }
      }
      //----------------------------------------------------------------
      if (isUseIdCard && !this.detail.id_card_image_watermark) {
        this.isLoading = false;
        return;
      }
      //----------------------------------------------------------------

      let answers = this.answer;
      if (Array.isArray(this.missionDetail?.schema_survey?.pages)) {
        let listComponentRanking = [];
        for (let item of this.missionDetail?.schema_survey?.pages) {
          let _list = item.elements?.filter((x) => x.type === "ranking");
          listComponentRanking = [...listComponentRanking, ..._list];
        }
        for (let item of listComponentRanking) {
          let model = answers[`${item.name}`];
          if (!model) {
            answers[`${item.name}`] = item.choices || [];
          }
        }
      }
      //===========================================
      if (typeof this.description !== "string") {
        this.description = "";
      }
      // ========== ========== ========== ==========
      this.loadingScreen = true;
      let formData = new FormData();
      formData.append("description", this.description);
      formData.append("image", this.image);
      formData.append("employee_mission_id", this.$route.params.id);
      formData.append("mission_rewards", JSON.stringify(rewardSelect));
      formData.append("address_id", addressId || "");
      formData.append(
        "id_card_image",
        this.detail.id_card_image_watermark || ""
      );
      formData.append("employee_note", this.detail.employee_note || "");
      // ========== ========== ========== ==========
      this.isAppLoading(true);
      let url = "/mission/updateMissionUploadImage";
      if (this.missionDetail.image_upload === "") {
        url = "/mission/confirmMissionUploadImage";
      }
      Axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2000,
            });
            setTimeout(() => {
              this.$router.push({
                name: "mission",
              });
            }, 2000);
          } else if (res.data.status == "error_try_again") {
            this.$swal
              .fire({
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                if (
                  this.missionDetail.use_reward &&
                  Array.isArray(this.missionDetail.mission_rewards) &&
                  this.missionDetail.mission_rewards.length > 0
                ) {
                  this.dialogRewardMission = true;
                } else {
                  this.$router.push({
                    name: "mission",
                  });
                }
              });
          } else {
            this.$swal.fire(this.$t("error.title"), res.data.error, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$swal
            .fire({
              icon: "error",
              text: err.response?.data?.message,
              showConfirmButton: false,
              timer: 2000,
            })
            .then(() => {
              if (
                this.missionDetail.use_reward &&
                Array.isArray(this.missionDetail.mission_rewards) &&
                this.missionDetail.mission_rewards.length > 0
              ) {
                this.dialogRewardMission = true;
              } else {
                this.$router.push({
                  name: "mission",
                });
              }
            });
        })
        .then(() => {
          setTimeout(() => {
            this.loadingScreen = false;
            this.isAppLoading(false);
          }, 2000);
        });
    },
  },
  watch: {},
  computed: {
    ...mapState("defaultSystem", ["site"]),
    showCommentField() {
      return this.missionDetail.mission_status == "waiting" ||
        this.missionDetail.mission_status == "reject"
        ? true
        : false;
    },
    pathImage() {
      return this.missionDetail.image_path || this.missionDetail.image_url;
    },
    noteFailTextarea() {
      return this.missionDetail.note ? this.dataItem.note : "-";
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
  },
};
</script>

<style>
.plyr--stopped.plyr__poster-enabled .plyr__poster {
  opacity: 0;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: center;
  padding-bottom: 50px;
}

.sd-element__title span {
  color: black;
}

.sd-item__control-label {
  color: black;
}
</style>

<style scoped>
.borderActive {
  border: 1px solid #5a5a5a;
  border-radius: 5px;
}

.description-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>